import { InputWrap, SimplifiedRHFErrors } from 'components/forms/bookingWidget/shared';
import TimePicker from 'components/forms/TimePicker/TimePicker';
import { DomesticV2BoatsIdCalendarGet200Response } from 'swagger/models';
import type { UseFormMethods } from 'react-hook-form';

interface ErrorWithTripTime extends SimplifiedRHFErrors {
  trip_time?: {
    message: string;
  };
}

interface StartTimeInputProps {
  isModal: boolean;
  errors?: ErrorWithTripTime;
  register: UseFormMethods['register'];
  boatCalendar: DomesticV2BoatsIdCalendarGet200Response;
  setExpanded?: (expanded: boolean) => void;
}
export default ({ isModal, errors, register, boatCalendar, setExpanded }: StartTimeInputProps) => (
  <InputWrap noBorder>
    <TimePicker
      modalVersion={isModal}
      error={errors?.trip_time?.message}
      calendar={boatCalendar}
      onChange={() => {
        if (setExpanded) setExpanded(true);
      }}
      useDuration
      editable
    />

    <input type="hidden" ref={register({ required: 'Please enter start time' })} name="trip_time" />
  </InputWrap>
);
